import {
  useWorkOrderTrackPageDataSourceContext,
  WorkOrderTrackPageDataSourceContextProvider
} from "./WorkOrderTrackPageDataSourceContext";

export default useWorkOrderTrackPageDataSourceContext;
export { WorkOrderTrackPageDataSourceContextProvider };
